import React, {useState, useEffect} from 'react'
import {getDetectedLocation, getLocation} from "../../utils/getLocation";
import {IsBrowser} from "../../utils/isBrowser";

const COUNTRY_CODE = process.env.GATSBY_LOCALE_COUNTRY;
const COUNTRIES = {
    NZ: {
        name: 'New Zealand',
        flag: '/flags/nz.svg',
        code: 'NZ',
        url: 'https://bushbuck.co.nz/'
    },
    AU: {
        name: 'Australia',
        flag: '/flags/au.svg',
        code: 'AU',
        url: 'https://bushbuck.com.au/'
    },
    GB: {
        name: 'Great Britain',
        flag: '/flags/gb.svg',
        code: 'GB',
        url: 'https://bushbuck.co.uk/'
    },
    US: {
        name: 'United States',
        flag: '/flags/us.svg',
        code: 'US',
        url: 'https://bushbuck.com/'
    }
}

export default function CountryPopup() {
    const [open, setOpen] = useState(false);
    const [dismissed, setDismissed] = useState(true);
    const [country, setCountry] = useState(null);
    const location = getLocation();
    const detectedLocation = getDetectedLocation();

    useEffect(() => {
        if (detectedLocation) {
            const hasBeenDismissed = IsBrowser() ? sessionStorage.getItem(`bushbuck_geopopup_dismissed_${COUNTRY_CODE}`) : false;
            if (!hasBeenDismissed) {
                setDismissed(false);
            }
        }
    }, [detectedLocation])

    useEffect(() => {
        if (!dismissed && detectedLocation && COUNTRIES[detectedLocation] && COUNTRY_CODE !== detectedLocation) {
            setCountry(COUNTRIES[detectedLocation]);
            setOpen(true);
        }
        if (!dismissed && detectedLocation && COUNTRIES[detectedLocation] && location !== detectedLocation) {
            setCountry(COUNTRIES[detectedLocation]);
            setOpen(true);
        }
    }, [dismissed, location, detectedLocation]);

    function handleDismiss() {
        if (IsBrowser()) {
            sessionStorage.setItem(`bushbuck_geopopup_dismissed_${COUNTRY_CODE}`, '1');
        }
        setDismissed(true);
        setOpen(false);
    }

    return (
        <div id="popup-modal" tabIndex="-1"
             className={`${open ? 'fixed' : 'hidden'} top-0 left-0 right-0 z-50 p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-[calc(100%-1rem)] max-h-full flex`}>
            {country && (<div className="relative w-full max-w-md max-h-full m-auto">
                <div className="relative bg-black bg-opacity-75 border-solid border-lightgray border-2 rounded-lg shadow dark:bg-gray-700">
                    <div className="p-6 text-center">
                        <h3 className="mb-5 text-lg font-normal text-lightgray">Heads up! You&apos;re in {country.name}. To ensure correct currency & shipping, you must shop on our {country.code} site.</h3>
                        <div className="m-auto w-40 mb-10">
                            <img src={country.flag} alt={country.name} className="w-full" />
                        </div>
                        <a href={country.url} data-modal-hide="popup-modal" type="button"
                                className="flex justify-center items-center bg-white text-black px-10 mb-5 h-10 rounded-full border-none outline-none font-semibold leading-4 text-center">
                            Take me to the {country.code} site.
                        </a>
                        <button onClick={handleDismiss} data-modal-hide="popup-modal" type="button"
                                className="py-3 px-10 mb-5 text-white underline underline-offset-4 font-semibold text-xs sm:text-base text-center sm:text-left">
                            Not in {country.code}?, I&apos;ll continue here.
                        </button>
                    </div>
                </div>
            </div>)}
        </div>
    )
}
